import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import ProductCategories from "@/pages/ProductCategories";
import HowItWorks from "@/pages/HowItWorks";
import Delivery from "@/pages/Delivery";
import OnlineOrdering from "@/pages/OnlineOrdering";
import Reporting from "@/pages/Reporting";
import PriceMatchPage from "@/pages/PriceMatchPage";
import BecomeCustomer from "@/pages/BecomeCustomer";
import Contact from "@/pages/Contact";
import FAQPage from "@/pages/FAQPage";
import Order from "@/pages/Order";
import PolicyPage from "@/pages/PolicyPage";
import NotFound from "@/pages/NotFound";
import { POLICY_LINKS } from "@/data/policies";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <Routes>
          <Route path="/order" element={<Order />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/product-categories" element={<ProductCategories />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/delivery" element={<Delivery />} />
            <Route path="/online-ordering" element={<OnlineOrdering />} />
            <Route path="/reporting" element={<Reporting />} />
            <Route path="/price-match" element={<PriceMatchPage />} />
            <Route path="/become-a-customer" element={<BecomeCustomer />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQPage />} />
            {POLICY_LINKS.map(({ slug }) => (
              <Route key={slug} path={`/${slug}`} element={<PolicyPage policyKey={slug} />} />
            ))}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
